import { Outlet, Navigate, useLocation } from "react-router-dom";

import NavBar, {
  SHIPPER_NAV_ITEMS,
  SHIPPER_HELPER_ALLOWED_URLS,
} from "../Navbar/ShipperNavBar";
import OneTimeShipperNavBar from "../Navbar/OneTimeShipperNavBar";

const shipperPermissions = [
  { url: "/", name: "shipper.access.shipment.view" },
  { url: "/shipments", name: "shipper.access.shipment.view" },
  { url: "/Invoices", name: "shipper.access.invoice.view" },
  { url: "/Pickup", name: "shipper.access.pickup.view" },
  { url: "/Tracking", name: "shipper.access.tracking.view" },
  { url: "/Packages", name: "shipper.access.product.view" },
  { url: "/products", name: "shipper.access.product.view" },
  { url: "/Marketplaces", name: "" },
  { url: "/Carriers", name: "shipper.access.carrier.view" },
  { url: "/Tickets", name: "shipper.access.ticket.view" },
  { url: "/orders", name: "shipper.access.order.view" },
  { url: "/orders/scans", name: "shipper.access.order.view" },
  { url: "/payments", name: "shipper.access.payment.view" },
  { url: "/settings/manage-helper-users", ownerOnly: true },
  { url: "/settings/manage-roles", ownerOnly: true },
  { url: "/settings/manage-permissions", ownerOnly: true },
  { url: "/settings/referrals", ownerOnly: true },
];

const normalizePath = (path) => (path || "").replace(/\/+$/, "").toLowerCase() || "/";

const navUrlSet = new Set(SHIPPER_NAV_ITEMS.map((i) => normalizePath(i.url)));
const helperAllowedSet = new Set(
  SHIPPER_HELPER_ALLOWED_URLS.map((u) => normalizePath(u))
);

const PrivateRoutes = (props) => {
  const role = localStorage.getItem("Role");
  const location = useLocation();

  if (
    role === "Shipper" ||
    role === "ShipperUser" ||
    role === "oneTimeShipper"
  ) {
    const isOwner =
      (role === "Shipper" || role === "oneTimeShipper") && !props?.parentId;
    const matched = shipperPermissions.find(
      (p) => normalizePath(p.url) === normalizePath(location.pathname)
    );

    const path = normalizePath(location.pathname);

    let allowed;
    if (matched?.ownerOnly) {
      allowed = isOwner;
    } else if (isOwner) {
      allowed = true;
    } else if (navUrlSet.has(path) && !helperAllowedSet.has(path)) {
      allowed = false;
    } else if (!matched || !matched.name) {
      allowed = true;
    } else {
      if (!Array.isArray(props?.mergedPermissions)) return null;
      allowed = props.mergedPermissions.includes(matched.name);
    }

    if (allowed) {
      return (
        <>
          {role === "oneTimeShipper" ? <OneTimeShipperNavBar /> : <NavBar />}
          <div className="bg-ui-bg">
            <Outlet />
          </div>
        </>
      );
    }
    return <Navigate to="/unauthorized" />;
  } else if (role === "Carrier") {
    return <Navigate to="/create-zone" />;
  } else if (role === "Admin") {
    return <Navigate to="/Users" />;
  } else if (role === "warehouseUser") {
    return <Navigate to="/warehouse-orders" />;
  } else {
    return <Navigate to="/Login" />;
  }
};

export default PrivateRoutes;
